// Interações e 3D da landing page (#site-principal). Script clássico, sem dependências:
// o CSP do site (script-src 'self' + CDNs fixas) não permite lib 3D nova sem mexer em
// header — então a projeção 3D é feita à mão em <canvas> 2D (wireframe/hologram, leve).
// Tudo aqui é progressivo: sem JS ou com prefers-reduced-motion, a página fica completa
// e estática (reveals só escondem conteúdo quando <html class="ls-on">).
// Ciclo de vida: um único rAF alimenta todas as cenas; IntersectionObserver pausa canvas
// fora da viewport — inclusive quando o app esconde #site-principal via showView().

(function () {
    'use strict';

    var root = document.getElementById('site-principal');
    if (!root) return;

    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var NO_HOVER = window.matchMedia('(hover: none)').matches;

    if (!REDUCED) document.documentElement.classList.add('ls-on');

    /* ── utils ──────────────────────────────────────────────────────────── */
    function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
    function lerp(a, b, t) { return a + (b - a) * t; }
    function easeOutExpo(t) { return t >= 1 ? 1 : 1 - Math.pow(2, -10 * t); }
    function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
    function fmtBR(n, dec) {
        return n.toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    }

    /* ── paleta (r,g,b — strings prontas pra rgba()) ────────────────────── */
    var GOLD = '212,175,55';
    var GOLDL = '229,198,101';
    var EMER = '16,196,124';
    var RED = '242,90,86';
    var WHT = '226,232,240';

    /* ══ 1. Reveal ao rolar ═══════════════════════════════════════════════ */
    function initReveal() {
        if (REDUCED || !('IntersectionObserver' in window)) return;
        // stagger automático: filhos [data-reveal] de um pai [data-reveal-stagger]
        // ganham atraso incremental sem precisar anotar delay um a um no HTML
        root.querySelectorAll('[data-reveal-stagger]').forEach(function (parent) {
            var passo = parseInt(parent.getAttribute('data-reveal-stagger'), 10) || 90;
            parent.querySelectorAll('[data-reveal]').forEach(function (el, i) {
                if (!el.getAttribute('data-reveal-delay')) el.setAttribute('data-reveal-delay', String(i * passo));
            });
        });
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var el = entry.target;
                var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
                el.style.transitionDelay = delay + 'ms';
                el.classList.add('ls-in');
                io.unobserve(el);
            });
        }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
        root.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
    }

    /* ══ 2. Contadores animados ═══════════════════════════════════════════ */
    function initCounters() {
        var els = root.querySelectorAll('[data-counter]');
        if (!els.length) return;
        if (REDUCED || !('IntersectionObserver' in window)) return; // HTML já traz o valor final
        els.forEach(function (el) { el.textContent = fmtBR(0, parseInt(el.getAttribute('data-dec'), 10) || 0); });
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var el = entry.target;
                io.unobserve(el);
                var alvo = parseFloat(el.getAttribute('data-counter'));
                var dec = parseInt(el.getAttribute('data-dec'), 10) || 0;
                var t0 = null;
                var DUR = 1700;
                function passo(ts) {
                    if (t0 === null) t0 = ts;
                    var p = easeOutExpo(clamp((ts - t0) / DUR, 0, 1));
                    el.textContent = fmtBR(alvo * p, dec);
                    if (p < 1) requestAnimationFrame(passo);
                }
                requestAnimationFrame(passo);
            });
        }, { threshold: 0.5 });
        els.forEach(function (el) { io.observe(el); });
    }

    /* ══ 3. Tilt 3D nos cards ═════════════════════════════════════════════ */
    function initTilt() {
        if (REDUCED || NO_HOVER) return;
        root.querySelectorAll('[data-tilt]').forEach(function (el) {
            var raf = 0, rx = 0, ry = 0, alvoX = 0, alvoY = 0, ativo = false;
            function frame() {
                rx = lerp(rx, alvoX, 0.14);
                ry = lerp(ry, alvoY, 0.14);
                el.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)' + (ativo ? ' translateY(-4px)' : '');
                if (ativo || Math.abs(rx) > 0.05 || Math.abs(ry) > 0.05) raf = requestAnimationFrame(frame);
                else { el.style.transform = ''; el.classList.remove('ls-tilting'); raf = 0; }
            }
            el.addEventListener('pointerenter', function () { ativo = true; el.classList.add('ls-tilting'); if (!raf) raf = requestAnimationFrame(frame); });
            el.addEventListener('pointermove', function (ev) {
                var r = el.getBoundingClientRect();
                alvoY = ((ev.clientX - r.left) / r.width - 0.5) * 10;
                alvoX = (0.5 - (ev.clientY - r.top) / r.height) * 8;
            });
            el.addEventListener('pointerleave', function () { ativo = false; alvoX = 0; alvoY = 0; });
        });
    }

    /* ══ 4. Nav compacta + parallax do hero ═══════════════════════════════ */
    function initNavEParallax() {
        var nav = root.querySelector('nav');
        var heroContent = document.getElementById('ls-hero-content');
        var heroCanvas = document.getElementById('ls-hero-canvas');
        var agendado = false;
        function aplicar() {
            agendado = false;
            var y = window.scrollY || 0;
            if (nav) nav.classList.toggle('ls-nav-scrolled', y > 14);
            if (!REDUCED && y < 900) {
                if (heroContent) heroContent.style.transform = 'translateY(' + (y * 0.16).toFixed(1) + 'px)';
                if (heroCanvas) heroCanvas.style.transform = 'translateY(' + (y * 0.07).toFixed(1) + 'px)';
            }
        }
        window.addEventListener('scroll', function () {
            if (!agendado) { agendado = true; requestAnimationFrame(aplicar); }
        }, { passive: true });
        aplicar();
    }

    /* ══ 5. Micro-engine 3D (projeção manual em canvas 2D) ════════════════ */
    var FOV = 430, ZOFF = 175;
    var CENAS_ATIVAS = [];
    var loopRodando = false;

    function loop3d(ts) {
        var algumaVisivel = false;
        for (var k = 0; k < CENAS_ATIVAS.length; k++) {
            var sc = CENAS_ATIVAS[k];
            if (!sc.visivel || sc.destruida) continue;
            algumaVisivel = true;
            var dt = sc._ts ? clamp((ts - sc._ts) / 1000, 0, 0.05) : 0.016;
            sc._ts = ts;
            sc.t += dt;
            passoCena(sc, dt);
        }
        if (algumaVisivel) requestAnimationFrame(loop3d);
        else { loopRodando = false; CENAS_ATIVAS.forEach(function (sc) { sc._ts = 0; }); }
    }

    function acordarLoop() {
        if (!loopRodando && !REDUCED) { loopRodando = true; requestAnimationFrame(loop3d); }
    }

    var ioCanvas = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var sc = entry.target._lsCena;
            if (!sc) return;
            sc.visivel = entry.isIntersecting;
            if (sc.visivel) acordarLoop();
        });
    }, { threshold: 0.04 }) : null;

    function mkCena(canvas, def) {
        var sc = {
            canvas: canvas,
            ctx: canvas.getContext('2d'),
            def: def,
            pts: [], eds: [],
            cam: { rx: def.rx || 0, ry: def.ry || 0 },
            mouse: { x: 0, y: 0 },
            t: 0, _ts: 0,
            w: 0, h: 0, dpr: 1,
            visivel: true,
            destruida: false,
            isModal: canvas && canvas.id === 'ls-modal-canvas',
            dados: {}
        };
        // API que os builders usam pra montar o modelo
        sc.P = function (x, y, z, o) {
            o = o || {};
            sc.pts.push({
                x: x, y: y, z: z, c: o.c || GOLD, r: o.r != null ? o.r : 2, a: o.a != null ? o.a : 1,
                lbl: o.lbl || null, lblC: o.lblC || null, lblDy: o.lblDy != null ? o.lblDy : 16
            });
            return sc.pts.length - 1;
        };
        sc.E = function (i, j, o) {
            o = o || {};
            sc.eds.push({ i: i, j: j, c: o.c || GOLD, a: o.a != null ? o.a : 0.5, w: o.w || 1 });
            return sc.eds.length - 1;
        };
        sc.box = function (cx, cy, cz, w, h, d, o) {
            var hw = w / 2, hh = h / 2, hd = d / 2, ids = [];
            for (var i = 0; i < 8; i++) {
                ids.push(sc.P(cx + (i & 1 ? hw : -hw), cy + (i & 2 ? hh : -hh), cz + (i & 4 ? hd : -hd), o));
            }
            var arestas = [[0, 1], [2, 3], [4, 5], [6, 7], [0, 2], [1, 3], [4, 6], [5, 7], [0, 4], [1, 5], [2, 6], [3, 7]];
            var eids = arestas.map(function (par) { return sc.E(ids[par[0]], ids[par[1]], o); });
            return { p: ids, e: eids };
        };
        sc.polilinha = function (coords, o) {
            var ids = coords.map(function (c) { return sc.P(c[0], c[1], c[2], o); });
            var eids = [];
            for (var i = 0; i < ids.length - 1; i++) eids.push(sc.E(ids[i], ids[i + 1], o));
            if (o && o.fechar) eids.push(sc.E(ids[ids.length - 1], ids[0], o));
            return { p: ids, e: eids };
        };
        def.build(sc);
        canvas._lsCena = sc;
        CENAS_ATIVAS.push(sc);
        if (REDUCED) { // um frame estático de "pose bonita" e pronto
            sc.t = 1.8;
            if (def.tick) def.tick(sc, 0.016);
            desenharCena(sc);
        } else {
            if (ioCanvas) ioCanvas.observe(canvas);
            acordarLoop();
        }
        return sc;
    }

    function destruirCena(sc) {
        sc.destruida = true;
        if (ioCanvas) ioCanvas.unobserve(sc.canvas);
        sc.canvas._lsCena = null;
        var idx = CENAS_ATIVAS.indexOf(sc);
        if (idx >= 0) CENAS_ATIVAS.splice(idx, 1);
    }

    function passoCena(sc, dt) {
        var def = sc.def;
        if (def.spin) sc.cam.ry += def.spin * dt;
        if (def.wobble) sc.cam.rx = (def.rx || 0) + Math.sin(sc.t * 0.5) * def.wobble;
        // offset de mouse (parallax) é somado direto no desenharCena, sem tocar na câmera
        if (def.tick) def.tick(sc, dt);
        desenharCena(sc);
    }

    function desenharCena(sc) {
        var canvas = sc.canvas, ctx = sc.ctx;
        var cw = canvas.clientWidth, ch = canvas.clientHeight;
        if (!cw || !ch) return; // canvas escondido (ex.: app aberto) — não desenha
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        if (sc.w !== cw || sc.h !== ch || sc.dpr !== dpr) {
            sc.w = cw; sc.h = ch; sc.dpr = dpr;
            canvas.width = Math.round(cw * dpr);
            canvas.height = Math.round(ch * dpr);
        }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, cw, ch);

        var rx = sc.cam.rx + (sc.def.mouse ? sc.mouse.y * 0.22 : 0);
        var ry = sc.cam.ry + (sc.def.mouse ? sc.mouse.x * 0.38 : 0);
        var cx = Math.cos(rx), sx = Math.sin(rx);
        var cy = Math.cos(ry), sy = Math.sin(ry);
        var fitVal = sc.isModal ? (sc.def.fitModal || sc.def.fit) : sc.def.fit;
        var unit = Math.min(cw, ch) / (fitVal || 320);
        var ox = cw / 2 + (sc.def.dx || 0) * unit;
        var oy = ch / 2 + (sc.def.dy || 0) * unit;

        var n = sc.pts.length;
        var px = sc._px, py = sc._py, ps = sc._ps;
        if (!px || px.length !== n) {
            px = sc._px = new Float32Array(n);
            py = sc._py = new Float32Array(n);
            ps = sc._ps = new Float32Array(n);
        }
        for (var i = 0; i < n; i++) {
            var p = sc.pts[i];
            var x1 = p.x * cy + p.z * sy;
            var z1 = -p.x * sy + p.z * cy;
            var y1 = p.y * cx - z1 * sx;
            var z2 = p.y * sx + z1 * cx;
            var s = FOV / (FOV + z2 + ZOFF);
            px[i] = ox + x1 * s * unit;
            py[i] = oy - y1 * s * unit;
            ps[i] = s;
        }

        // 1) Arestas primeiro (embaixo)
        for (var e = 0; e < sc.eds.length; e++) {
            var ed = sc.eds[e];
            if (ed.a <= 0.01) continue;
            var prof = clamp(((ps[ed.i] + ps[ed.j]) / 2 - 0.60) / 0.28, 0.22, 1);
            ctx.globalAlpha = ed.a * prof;
            ctx.strokeStyle = 'rgb(' + ed.c + ')';
            ctx.lineWidth = ed.w;
            ctx.beginPath();
            ctx.moveTo(px[ed.i], py[ed.i]);
            ctx.lineTo(px[ed.j], py[ed.j]);
            ctx.stroke();
        }

        // 2) Pontos por cima com aura tripla
        for (var q = 0; q < n; q++) {
            var pt = sc.pts[q];
            if (pt.a <= 0.01 || pt.r <= 0) continue;
            var prof2 = clamp((ps[q] - 0.60) / 0.28, 0.22, 1);
            var raio = pt.r * ps[q];
            
            // Aura externa difusa
            ctx.globalAlpha = 0.14 * pt.a * prof2;
            ctx.fillStyle = 'rgb(' + pt.c + ')';
            ctx.beginPath();
            ctx.arc(px[q], py[q], raio * 3.8, 0, 6.2832);
            ctx.fill();

            // Halo médio de resplandecência
            ctx.globalAlpha = 0.28 * pt.a * prof2;
            ctx.beginPath();
            ctx.arc(px[q], py[q], raio * 2.2, 0, 6.2832);
            ctx.fill();

            // Núcleo sólido brilhante
            ctx.globalAlpha = pt.a * prof2;
            ctx.beginPath();
            ctx.arc(px[q], py[q], raio, 0, 6.2832);
            ctx.fill();
        }

        // 3) Rótulos de texto (nomes dos módulos) — por cima de tudo com nitidez aumentada
        for (var q2 = 0; q2 < n; q2++) {
            var pt2 = sc.pts[q2];
            if (!pt2.lbl || pt2.a <= 0.01 || sc.isModal) continue;
            var prof3 = clamp((ps[q2] - 0.60) / 0.28, 0.4, 1);
            var fontSize = Math.max(11, Math.min(15, 14 * ps[q2])).toFixed(1);

            ctx.font = '700 ' + fontSize + 'px Inter, "Segoe UI", sans-serif';
            ctx.textAlign = 'center';

            var tx = px[q2], ty = py[q2] + pt2.lblDy * ps[q2];
            
            // Fundo escuro sutil atrás das letras para perfeitamente contrastar
            ctx.globalAlpha = Math.min(0.85, pt2.a * prof3);
            ctx.fillStyle = 'rgba(7, 25, 43, 0.9)';
            ctx.fillText(pt2.lbl, tx + 1, ty + 1);

            // Texto frontal brilhante
            ctx.globalAlpha = Math.min(1, pt2.a * prof3 + 0.2);
            ctx.fillStyle = 'rgb(' + (pt2.lblC || WHT) + ')';
            ctx.fillText(pt2.lbl, tx, ty);
        }
        ctx.globalAlpha = 1;
    }

    /* helpers de geometria compartilhados pelas cenas */
    function amostrarBezier(p0, p1, p2, p3, n, saida) {
        for (var i = 1; i <= n; i++) {
            var t = i / n, u = 1 - t;
            saida.push([
                u * u * u * p0[0] + 3 * u * u * t * p1[0] + 3 * u * t * t * p2[0] + t * t * t * p3[0],
                u * u * u * p0[1] + 3 * u * u * t * p1[1] + 3 * u * t * t * p2[1] + t * t * t * p3[1]
            ]);
        }
        return saida;
    }

    // Contorno do escudo da logo (path do SVG da marca, amostrado e centrado)
    function contornoEscudo() {
        var pts2d = [[40, 0], [80, 13.3], [80, 46.6]];
        amostrarBezier([80, 46.6], [80, 73.3], [56.6, 90], [40, 96.6], 7, pts2d);
        amostrarBezier([40, 96.6], [23.3, 90], [0, 73.3], [0, 46.6], 7, pts2d);
        pts2d.push([0, 13.3]);
        var sc = 1.95;
        return pts2d.map(function (p) { return [(p[0] - 40) * sc, (48.3 - p[1]) * sc]; });
    }

    function gridChao(sc, y, tam, div, o) {
        var passo = tam / div, h = tam / 2;
        for (var i = 0; i <= div; i++) {
            var v = -h + i * passo;
            sc.E(sc.P(-h, y, v, { r: 0 }), sc.P(h, y, v, { r: 0 }), o);
            sc.E(sc.P(v, y, -h, { r: 0 }), sc.P(v, y, h, { r: 0 }), o);
        }
    }

    /* ══ 6. Cenas ═════════════════════════════════════════════════════════ */
    var CENAS = {};

    // — HERO: escudo da marca em holograma + check desenhando + partículas —
    CENAS.hero = {
        fit: 360, rx: -0.10, spin: 0.16, wobble: 0.05, mouse: true,
        build: function (sc) {
            var contorno = contornoEscudo();
            [16, -16].forEach(function (z, camada) {
                var alpha = camada === 0 ? 1 : 0.5;
                var anel = sc.polilinha(contorno.map(function (p) { return [p[0], p[1], z]; }),
                    { c: GOLD, a: alpha * 0.65, w: 1.5, fechar: true, r: camada === 0 ? 2 : 1.3 });
                sc.dados['anel' + camada] = anel;
            });
            // travessas ligando as duas camadas
            var n = contorno.length;
            for (var i = 0; i < n; i += 2) {
                sc.E(sc.dados.anel0.p[i], sc.dados.anel1.p[i], { c: GOLD, a: 0.3, w: 1 });
            }
            // check da marca (desenha e apaga em ciclo)
            var scF = 1.95;
            var check = [[10, 53], [30, 73], [70, 20]].map(function (p) {
                return [(p[0] - 40) * scF, (48.3 - p[1]) * scF, 0];
            });
            sc.dados.check = sc.polilinha(check, { c: EMER, a: 0, w: 3, r: 2.6 });
            sc.dados.check.p.forEach(function (id) { sc.pts[id].c = EMER; sc.pts[id].a = 0; });
            // anel orbital
            var orbita = [];
            for (var k = 0; k < 36; k++) {
                var ang = (k / 36) * Math.PI * 2;
                orbita.push([Math.cos(ang) * 205, Math.sin(ang) * 34, Math.sin(ang) * 205]);
            }
            sc.dados.orbita = sc.polilinha(orbita, { c: EMER, a: 0.16, w: 1, fechar: true, r: 0 });
            sc.dados.orbPonto = sc.P(205, 0, 0, { c: EMER, r: 2.6, a: 0.9 });
            // campo de partículas com conexões
            var livres = [];
            for (var m = 0; m < 64; m++) {
                var r = 165 + Math.random() * 105;
                var th = Math.random() * Math.PI * 2;
                var ph = Math.acos(2 * Math.random() - 1);
                var x = r * Math.sin(ph) * Math.cos(th), y = r * Math.cos(ph) * 0.72, z = r * Math.sin(ph) * Math.sin(th);
                livres.push({
                    id: sc.P(x, y, z, { c: Math.random() < 0.28 ? GOLDL : WHT, r: 1.5 + Math.random() * 1.3, a: 0.35 + Math.random() * 0.45 }),
                    bx: x, by: y, bz: z, f1: 0.3 + Math.random() * 0.7, f2: Math.random() * 6.28
                });
            }
            for (var a = 0; a < livres.length; a++) {
                for (var b = a + 1; b < livres.length; b++) {
                    var dx = livres[a].bx - livres[b].bx, dyy = livres[a].by - livres[b].by, dz = livres[a].bz - livres[b].bz;
                    if (dx * dx + dyy * dyy + dz * dz < 78 * 78) sc.E(livres[a].id, livres[b].id, { c: WHT, a: 0.10, w: 0.7 });
                }
            }
            sc.dados.livres = livres;
        },
        tick: function (sc) {
            // deriva suave das partículas em torno da posição base
            sc.dados.livres.forEach(function (pp) {
                var p = sc.pts[pp.id];
                p.x = pp.bx + Math.sin(sc.t * pp.f1 + pp.f2) * 7;
                p.y = pp.by + Math.cos(sc.t * pp.f1 * 0.8 + pp.f2) * 7;
                p.z = pp.bz + Math.sin(sc.t * pp.f1 * 0.6 + pp.f2 * 2) * 7;
            });
            // ponto correndo na órbita
            var op = sc.pts[sc.dados.orbPonto];
            var ang = sc.t * 0.55;
            op.x = Math.cos(ang) * 205; op.y = Math.sin(ang) * 34; op.z = Math.sin(ang) * 205;
            // ciclo do check: desenha (1.4s) → segura (2.6s) → some (0.8s)
            var ciclo = sc.t % 5.4;
            var prog = ciclo < 1.4 ? easeInOut(ciclo / 1.4) : (ciclo < 4.0 ? 1 : Math.max(0, 1 - (ciclo - 4.0) / 0.8));
            var eds = sc.dados.check.e, pts = sc.dados.check.p;
            var totalSeg = eds.length;
            eds.forEach(function (eid, i) {
                var ini = i / totalSeg, fim = (i + 1) / totalSeg;
                sc.eds[eid].a = clamp((prog - ini) / (fim - ini), 0, 1) * 0.95;
            });
            pts.forEach(function (pid, i) {
                sc.pts[pid].a = prog >= i / totalSeg ? 0.95 : 0;
            });
        }
    };

    // — IA: os módulos da plataforma conversando entre si, com a IA no centro —
    CENAS.hubIA = {
        fit: 210, fitModal: 320, rx: -0.24, spin: 0.12, wobble: 0.05,
        build: function (sc) {
            sc.dados.centro = sc.P(0, 0, 0, { c: GOLDL, r: 7.0, a: 1, lbl: 'IA', lblC: GOLDL, lblDy: -20 });
            // anel duplo em volta do núcleo
            [42, 28].forEach(function (r, ri) {
                var coords = [];
                for (var k = 0; k < 28; k++) {
                    var ang = (k / 28) * Math.PI * 2;
                    coords.push([Math.cos(ang) * r, Math.sin(ang) * r * (ri === 0 ? 0.5 : 1), Math.sin(ang) * r * (ri === 0 ? 1 : 0.35)]);
                }
                sc.polilinha(coords, { c: GOLD, a: ri === 0 ? 0.5 : 0.3, w: 1.2, fechar: true, r: 0 });
            });
            // 8 módulos nomeados em anel 3D, alturas alternadas
            var nomes = ['Painel', 'Inventário', 'Validade', 'Caixa', 'Docas', 'Negativos', 'Checklist', 'Tarefas'];
            sc.dados.nos = nomes.map(function (nome, i) {
                var ang = (i / nomes.length) * Math.PI * 2;
                var x = Math.cos(ang) * 125, z = Math.sin(ang) * 125;
                var y = (i % 2 ? 35 : -35);
                var id = sc.P(x, y, z, { c: WHT, r: 4.8, a: 0.95, lbl: nome, lblC: WHT, lblDy: 22 });
                var e = sc.E(sc.dados.centro, id, { c: EMER, a: 0.30, w: 1.4 });
                return { id: id, bx: x, by: y, bz: z, e: e, fase: i * 0.8 };
            });
            // conversas laterais entre módulos vizinhos
            for (var i = 0; i < sc.dados.nos.length; i++) {
                sc.E(sc.dados.nos[i].id, sc.dados.nos[(i + 1) % sc.dados.nos.length].id, { c: WHT, a: 0.09, w: 0.7 });
            }
            // pulsos de conversa (módulo↔IA e módulo↔módulo)
            sc.dados.pulsos = [];
            for (var k2 = 0; k2 < 9; k2++) {
                sc.dados.pulsos.push({ id: sc.P(0, 0, 0, { c: GOLDL, r: 2.4, a: 0 }), de: null, para: null, ar: -1, t: Math.random() });
            }
        },
        tick: function (sc, dt) {
            // respiração dos nós
            sc.dados.nos.forEach(function (no) {
                var p = sc.pts[no.id];
                p.y = no.by + Math.sin(sc.t * 0.9 + no.fase) * 4;
            });
            sc.dados.pulsos.forEach(function (pu, k) {
                if (pu.de === null) {
                    var nos = sc.dados.nos;
                    var a = nos[Math.floor(Math.random() * nos.length)];
                    if (k % 3 === 2) { // conversa lateral módulo→módulo
                        var b = nos[(nos.indexOf(a) + 1) % nos.length];
                        pu.de = a.id; pu.para = b.id; pu.ar = -1;
                    } else if (Math.random() < 0.5) { // módulo → IA
                        pu.de = a.id; pu.para = sc.dados.centro; pu.ar = a.e;
                    } else { // IA → módulo
                        pu.de = sc.dados.centro; pu.para = a.id; pu.ar = a.e;
                    }
                    pu.t = 0;
                }
                pu.t += dt * 1.1;
                var A = sc.pts[pu.de], B = sc.pts[pu.para];
                var p = sc.pts[pu.id];
                var e2 = easeInOut(clamp(pu.t, 0, 1));
                p.x = lerp(A.x, B.x, e2); p.y = lerp(A.y, B.y, e2); p.z = lerp(A.z, B.z, e2);
                p.a = pu.t < 1 ? 0.95 : 0;
                p.c = (pu.para === sc.dados.centro) ? GOLDL : EMER;
                if (pu.ar >= 0) sc.eds[pu.ar].a = pu.t < 1 ? 0.45 : 0.18;
                if (pu.t >= 1) {
                    B.r = (B === sc.pts[sc.dados.centro]) ? 6 : 4.6; // quem recebe, acende
                    pu.de = null;
                }
            });
            sc.pts.forEach(function (p, i) {
                var base = (i === sc.dados.centro) ? 4.4 : 3;
                if (p.lbl && p.r > base) p.r = Math.max(base, p.r - dt * 4);
            });
        }
    };

    // — PAINEL BI: barras 3D subindo sobre grid —
    CENAS.bars = {
        fit: 330, rx: -0.30, spin: 0.22,
        build: function (sc) {
            gridChao(sc, -72, 250, 5, { c: WHT, a: 0.10, w: 0.8 });
            sc.dados.barras = [];
            for (var i = 0; i < 5; i++) {
                for (var j = 0; j < 3; j++) {
                    var alvo = 30 + Math.random() * 105;
                    var b = sc.box(-90 + i * 45, -72 + alvo / 2, -45 + j * 45, 26, alvo, 26, { c: GOLD, a: 0.5, w: 1.1, r: 0 });
                    // os 4 pontos do topo ganham brilho
                    [2, 3, 6, 7].forEach(function (k) { sc.pts[b.p[k]].r = 1.7; sc.pts[b.p[k]].a = 0.85; });
                    sc.dados.barras.push({ box: b, h: alvo, alvo: alvo, cx: -90 + i * 45, cz: -45 + j * 45 });
                }
            }
        },
        tick: function (sc, dt) {
            if (Math.floor(sc.t / 2.8) !== Math.floor((sc.t - dt) / 2.8)) {
                sc.dados.barras.forEach(function (b) { b.alvo = 30 + Math.random() * 105; });
            }
            var maxH = 0, maxB = null;
            sc.dados.barras.forEach(function (b) { if (b.alvo > maxH) { maxH = b.alvo; maxB = b; } });
            sc.dados.barras.forEach(function (b) {
                b.h = lerp(b.h, b.alvo, 1 - Math.pow(0.04, dt));
                var topo = -72 + b.h, base = -72;
                b.box.p.forEach(function (pid, k) {
                    sc.pts[pid].y = (k & 2) ? topo : base;
                    var cor = (b === maxB) ? EMER : GOLD;
                    sc.pts[pid].c = cor;
                });
                b.box.e.forEach(function (eid) { sc.eds[eid].c = (b === maxB) ? EMER : GOLD; });
            });
        }
    };

    // — INVENTÁRIO: plano de scan varrendo caixas, que "contam" em verde —
    CENAS.scangrid = {
        fit: 330, rx: -0.22, spin: 0.10,
        build: function (sc) {
            gridChao(sc, -68, 260, 5, { c: WHT, a: 0.08, w: 0.8 });
            sc.dados.caixas = [];
            for (var i = 0; i < 4; i++) {
                for (var j = 0; j < 2; j++) {
                    for (var k = 0; k < 2; k++) {
                        var cx = -84 + i * 56;
                        var box = sc.box(cx, -50 + j * 40, -30 + k * 60, 34, 34, 34, { c: GOLD, a: 0.35, w: 1, r: 0 });
                        sc.dados.caixas.push({ box: box, cx: cx, ok: false });
                    }
                }
            }
            var pl = { c: EMER, a: 0.55, w: 1.6, r: 0 };
            sc.dados.plano = sc.polilinha([[0, -75, -75], [0, 55, -75], [0, 55, 75], [0, -75, 75]], Object.assign({ fechar: true }, pl));
            sc.dados.diag = [sc.E(sc.dados.plano.p[0], sc.dados.plano.p[2], { c: EMER, a: 0.15, w: 0.8 }),
                sc.E(sc.dados.plano.p[1], sc.dados.plano.p[3], { c: EMER, a: 0.15, w: 0.8 })];
        },
        tick: function (sc) {
            var ciclo = 5.4, meia = ciclo / 2;
            var fase = sc.t % ciclo;
            var sxPos = fase < meia ? lerp(-125, 125, fase / meia) : lerp(125, -125, (fase - meia) / meia);
            var indo = fase < meia;
            sc.dados.plano.p.forEach(function (pid) { sc.pts[pid].x = sxPos; });
            sc.dados.caixas.forEach(function (cb) {
                var contada = indo ? (cb.cx < sxPos) : (cb.cx > sxPos);
                var cor = contada ? EMER : GOLD;
                var alpha = contada ? 0.8 : 0.35;
                cb.box.e.forEach(function (eid) { sc.eds[eid].c = cor; sc.eds[eid].a = alpha; });
            });
        }
    };

    // — VALIDADE: esteira rumo ao limite; item crítico é resgatado antes —
    CENAS.expiry = {
        fit: 330, rx: -0.16, ry: 0.85, spin: 0.04,
        build: function (sc) {
            // trilho
            sc.E(sc.P(-24, -46, -170, { r: 0 }), sc.P(-24, -46, 130, { r: 0 }), { c: WHT, a: 0.2, w: 1 });
            sc.E(sc.P(24, -46, -170, { r: 0 }), sc.P(24, -46, 130, { r: 0 }), { c: WHT, a: 0.2, w: 1 });
            // plano-limite ("hoje")
            sc.polilinha([[-70, -50, 85], [-70, 55, 85], [70, 55, 85], [70, -50, 85]], { c: RED, a: 0.6, w: 1.6, fechar: true, r: 1.6 });
            sc.dados.itens = [];
            for (var i = 0; i < 6; i++) {
                var z = -160 + i * 48;
                sc.dados.itens.push({ box: sc.box(0, -28, z, 34, 34, 34, { c: EMER, a: 0.6, w: 1.2, r: 0 }), z: z, lift: 0 });
            }
        },
        tick: function (sc, dt) {
            sc.dados.itens.forEach(function (it) {
                it.z += dt * 26;
                var cor, resgate = it.z > 55;
                if (resgate) it.lift = Math.min(1, it.lift + dt * 1.6);
                var lift = easeInOut(it.lift) * 85;
                var alpha = 0.6 * (1 - it.lift * 0.9) + 0.05;
                if (it.z < -20) cor = EMER;
                else if (it.z < 38) cor = GOLD;
                else cor = RED;
                if (it.lift > 0) cor = EMER; // resgatado = perda evitada
                it.box.p.forEach(function (pid, k) {
                    var p = sc.pts[pid];
                    p.z = it.z + ((k & 4) ? 17 : -17);
                    p.y = -28 + lift + ((k & 2) ? 17 : -17);
                });
                it.box.e.forEach(function (eid) { sc.eds[eid].c = cor; sc.eds[eid].a = alpha; });
                if (it.z > 80 || it.lift >= 1) { it.z = -170; it.lift = 0; }
            });
        }
    };

    // — CHECKLIST: prancheta com itens sendo checados em sequência —
    CENAS.checklist = {
        fit: 300, rx: -0.06, ry: -0.35, wobble: 0.07, spin: 0,
        build: function (sc) {
            sc.polilinha([[-75, 105, 0], [75, 105, 0], [75, -105, 0], [-75, -105, 0]], { c: WHT, a: 0.5, w: 1.5, fechar: true, r: 1.6 });
            sc.polilinha([[-22, 105, 0], [-22, 121, 0], [22, 121, 0], [22, 105, 0]], { c: GOLD, a: 0.7, w: 1.5, r: 0 });
            sc.dados.linhas = [];
            for (var i = 0; i < 5; i++) {
                var y = 70 - i * 38;
                var boxq = sc.polilinha([[-58, y + 9, 0], [-40, y + 9, 0], [-40, y - 9, 0], [-58, y - 9, 0]], { c: WHT, a: 0.4, w: 1.2, fechar: true, r: 0 });
                var texto = sc.E(sc.P(-28, y, 0, { r: 0 }), sc.P(56, y, 0, { r: 0 }), { c: WHT, a: 0.3, w: 2.5 });
                var check = sc.polilinha([[-55, y, 0], [-49, y - 6, 0], [-42, y + 7, 0]], { c: EMER, a: 0, w: 2.6, r: 0 });
                sc.dados.linhas.push({ boxq: boxq, texto: texto, check: check });
            }
        },
        tick: function (sc) {
            var ciclo = sc.t % 8.2;
            sc.dados.linhas.forEach(function (ln, i) {
                var ini = 0.6 + i * 1.15;
                var prog = clamp((ciclo - ini) / 0.5, 0, 1);
                ln.check.e.forEach(function (eid, k) {
                    sc.eds[eid].a = clamp(prog * 2 - k, 0, 1) * 0.95;
                });
                sc.eds[ln.texto].c = prog >= 1 ? EMER : WHT;
                sc.eds[ln.texto].a = prog >= 1 ? 0.55 : 0.3;
                ln.boxq.e.forEach(function (eid) {
                    sc.eds[eid].c = prog > 0 ? EMER : WHT;
                    sc.eds[eid].a = prog > 0 ? 0.8 : 0.4;
                });
            });
        }
    };

    // — CAIXA & PREÇOS: etiquetas passando pelo feixe do leitor —
    CENAS.pdv = {
        fit: 310, rx: -0.12, spin: 0.06,
        build: function (sc) {
            // feixe do scanner
            sc.E(sc.P(0, 78, 0, { c: EMER, r: 2.6, a: 0.9 }), sc.P(0, -62, 0, { r: 0 }), { c: EMER, a: 0.5, w: 1.6 });
            gridChao(sc, -66, 240, 4, { c: WHT, a: 0.07, w: 0.8 });
            sc.dados.tags = [];
            for (var i = 0; i < 4; i++) {
                var x = -170 + i * 85;
                // etiqueta de preço: casinha deitada (pentágono)
                var forma = [[-22, 14, 0], [10, 14, 0], [24, 0, 0], [10, -14, 0], [-22, -14, 0]];
                var tag = sc.polilinha(forma.map(function (p) { return [p[0] + x, p[1], 0]; }), { c: GOLD, a: 0.6, w: 1.4, fechar: true, r: 1.4 });
                var furo = sc.P(x + 16, 0, 0, { c: GOLD, r: 1.8, a: 0.7 });
                sc.dados.tags.push({ tag: tag, furo: furo, x: x, estado: 0, idx: i });
            }
        },
        tick: function (sc, dt) {
            sc.dados.tags.forEach(function (tg) {
                var antes = tg.x;
                tg.x += dt * 46;
                if (antes < 0 && tg.x >= 0) tg.estado = (tg.idx % 3 === 2) ? 2 : 1; // a cada 3, uma divergência pega
                if (tg.x > 190) { tg.x = -190; tg.estado = 0; tg.idx = (tg.idx + 1) % 3; }
                var cor = tg.estado === 0 ? GOLD : (tg.estado === 2 && tg.x < 55 ? RED : EMER);
                var flash = Math.abs(tg.x) < 10 ? 1 : 0.6;
                tg.tag.e.forEach(function (eid) { sc.eds[eid].c = cor; sc.eds[eid].a = flash; });
                tg.tag.p.forEach(function (pid, k) {
                    sc.pts[pid].x = [-22, 10, 24, 10, -22][k] + tg.x;
                    sc.pts[pid].c = cor;
                });
                sc.pts[tg.furo].x = tg.x + 16;
                sc.pts[tg.furo].c = cor;
            });
        }
    };

    // — DOCAS: caixas cruzando o portal de conferência; suspeita é desviada —
    CENAS.docas = {
        fit: 340, rx: -0.18, spin: 0.07,
        build: function (sc) {
            gridChao(sc, -60, 260, 5, { c: WHT, a: 0.08, w: 0.8 });
            // portal
            sc.polilinha([[0, -60, -55], [0, 62, -55], [0, 62, 55], [0, -60, 55]], { c: GOLD, a: 0.8, w: 2, r: 1.8 });
            sc.dados.caixas = [];
            for (var i = 0; i < 4; i++) {
                var x = -180 + i * 90;
                sc.dados.caixas.push({ box: sc.box(x, -40, 0, 36, 36, 36, { c: WHT, a: 0.45, w: 1.2, r: 0 }), x: x, sobe: 0, marcada: i === 2 });
            }
        },
        tick: function (sc, dt) {
            sc.dados.caixas.forEach(function (cb) {
                cb.x += dt * 42;
                var passou = cb.x > 0;
                if (cb.marcada && cb.x > 55) cb.sobe = Math.min(1, cb.sobe + dt * 1.8);
                var lift = easeInOut(cb.sobe) * 75;
                var cor = !passou ? WHT : (cb.marcada ? RED : EMER);
                var alpha = (0.45 + (Math.abs(cb.x) < 12 ? 0.4 : 0)) * (1 - cb.sobe * 0.85);
                cb.box.p.forEach(function (pid, k) {
                    sc.pts[pid].x = cb.x + ((k & 1) ? 18 : -18);
                    sc.pts[pid].y = -40 + lift + ((k & 2) ? 18 : -18);
                });
                cb.box.e.forEach(function (eid) { sc.eds[eid].c = cor; sc.eds[eid].a = alpha; });
                if (cb.x > 190 || cb.sobe >= 1) { cb.x = -190; cb.sobe = 0; cb.marcada = Math.random() < 0.3; }
            });
        }
    };

    // — NEGATIVOS: barras abaixo do plano zero sendo corrigidas —
    CENAS.negbars = {
        fit: 330, rx: -0.24, spin: 0.14,
        build: function (sc) {
            // plano zero destacado
            sc.polilinha([[-120, 0, -55], [120, 0, -55], [120, 0, 55], [-120, 0, 55]], { c: GOLDL, a: 0.5, w: 1.4, fechar: true, r: 0 });
            gridChao(sc, 0, 240, 4, { c: WHT, a: 0.06, w: 0.7 });
            sc.dados.barras = [];
            for (var i = 0; i < 8; i++) {
                var alvo = (i % 3 === 1) ? -(25 + Math.random() * 45) : (20 + Math.random() * 70);
                var b = sc.box(-98 + i * 28, alvo / 2, 0, 18, Math.abs(alvo), 18, { c: alvo < 0 ? RED : EMER, a: 0.55, w: 1.1, r: 0 });
                sc.dados.barras.push({ box: b, h: alvo, alvo: alvo });
            }
        },
        tick: function (sc, dt) {
            if (Math.floor(sc.t / 3.4) !== Math.floor((sc.t - dt) / 3.4)) {
                sc.dados.barras.forEach(function (b, i) {
                    // negativos "acatados" viram positivos; alguns voltam a negativar (rotina diária)
                    b.alvo = (b.alvo < 0) ? (20 + Math.random() * 55) : ((i % 4 === 2 && Math.random() < 0.5) ? -(20 + Math.random() * 45) : (20 + Math.random() * 70));
                });
            }
            sc.dados.barras.forEach(function (b) {
                b.h = lerp(b.h, b.alvo, 1 - Math.pow(0.05, dt));
                var cor = b.h < 0 ? RED : EMER;
                b.box.p.forEach(function (pid, k) {
                    sc.pts[pid].y = (k & 2) ? Math.max(b.h, 0) : Math.min(b.h, 0);
                    sc.pts[pid].c = cor;
                });
                b.box.e.forEach(function (eid) { sc.eds[eid].c = cor; });
            });
        }
    };

    // — USO E CONSUMO: pacotes fluindo entre lojas com posto de aprovação —
    CENAS.flow = {
        fit: 330, rx: -0.14, wobble: 0.06, spin: 0,
        build: function (sc) {
            function hexPrisma(cx, cor) {
                [24, -24].forEach(function (y) {
                    var coords = [];
                    for (var k = 0; k < 6; k++) {
                        var ang = (k / 6) * Math.PI * 2 + 0.52;
                        coords.push([cx + Math.cos(ang) * 34, y, Math.sin(ang) * 34]);
                    }
                    sc.polilinha(coords, { c: cor, a: 0.7, w: 1.5, fechar: true, r: 1.6 });
                });
                for (var k = 0; k < 6; k++) {
                    var n1 = sc.pts.length - 12 + k, n2 = sc.pts.length - 6 + k;
                    sc.E(n1, n2, { c: cor, a: 0.35, w: 1 });
                }
            }
            hexPrisma(-105, GOLD);
            hexPrisma(105, EMER);
            // rota em arco
            var rota = [];
            for (var i = 0; i <= 24; i++) {
                var t = i / 24, x = lerp(-105, 105, t);
                rota.push([x, Math.sin(t * Math.PI) * 62, Math.sin(t * Math.PI * 2) * 12]);
            }
            sc.polilinha(rota, { c: WHT, a: 0.16, w: 1, r: 0 });
            sc.dados.rota = rota;
            // posto de aprovação no meio (losango girando via coordenadas)
            sc.dados.postoIds = sc.polilinha([[0, 84, 0], [14, 62, 0], [0, 40, 0], [-14, 62, 0]], { c: GOLDL, a: 0.85, w: 1.6, fechar: true, r: 1.6 }).p;
            sc.dados.pacotes = [];
            for (var k2 = 0; k2 < 3; k2++) {
                sc.dados.pacotes.push({ id: sc.P(-105, 24, 0, { c: GOLDL, r: 3, a: 0.9 }), t: k2 * 0.33, pausa: 0 });
            }
        },
        tick: function (sc, dt) {
            // losango do posto gira
            var ang = sc.t * 1.4;
            var base = [[0, 84], [14, 62], [0, 40], [-14, 62]];
            sc.dados.postoIds.forEach(function (pid, k) {
                var bx = base[k][0];
                sc.pts[pid].x = bx * Math.cos(ang);
                sc.pts[pid].z = bx * Math.sin(ang);
            });
            sc.dados.pacotes.forEach(function (pc) {
                if (pc.pausa > 0) { pc.pausa -= dt; }
                else {
                    var antes = pc.t;
                    pc.t += dt * 0.16;
                    if (antes < 0.5 && pc.t >= 0.5) pc.pausa = 0.55; // parada pra aprovação
                }
                if (pc.t >= 1) pc.t = 0;
                var rota = sc.dados.rota;
                var f = pc.t * (rota.length - 1);
                var i0 = Math.min(Math.floor(f), rota.length - 2);
                var fr = f - i0;
                var p = sc.pts[pc.id];
                p.x = lerp(rota[i0][0], rota[i0 + 1][0], fr);
                p.y = lerp(rota[i0][1], rota[i0 + 1][1], fr);
                p.z = lerp(rota[i0][2], rota[i0 + 1][2], fr);
                p.c = pc.t < 0.5 ? GOLDL : EMER; // depois de aprovado, muda de cor
                p.r = pc.pausa > 0 ? 4.6 : 3;
            });
        }
    };

    // — SCORE DE RISCO: radar varrendo blips por filial —
    CENAS.radar = {
        fit: 300, rx: -1.02, spin: 0,
        build: function (sc) {
            [42, 78, 112].forEach(function (r) {
                var coords = [];
                for (var k = 0; k < 40; k++) {
                    var ang = (k / 40) * Math.PI * 2;
                    coords.push([Math.cos(ang) * r, 0, Math.sin(ang) * r]);
                }
                sc.polilinha(coords, { c: EMER, a: r === 112 ? 0.4 : 0.18, w: 1, fechar: true, r: 0 });
            });
            sc.E(sc.P(-112, 0, 0, { r: 0 }), sc.P(112, 0, 0, { r: 0 }), { c: EMER, a: 0.12, w: 0.8 });
            sc.E(sc.P(0, 0, -112, { r: 0 }), sc.P(0, 0, 112, { r: 0 }), { c: EMER, a: 0.12, w: 0.8 });
            sc.dados.centro = sc.P(0, 0, 0, { c: EMER, r: 2.4, a: 0.9 });
            // vassoura: 6 linhas esmaecendo
            sc.dados.vassoura = [];
            for (var v = 0; v < 6; v++) {
                sc.dados.vassoura.push({ ponta: sc.P(112, 0, 0, { r: 0 }), e: sc.E(sc.dados.centro, sc.pts.length - 1, { c: EMER, a: 0.5 - v * 0.08, w: v === 0 ? 1.8 : 1 }) });
            }
            sc.dados.blips = [];
            var cores = [EMER, EMER, EMER, GOLD, GOLD, GOLD, RED, RED];
            for (var b = 0; b < 8; b++) {
                var ang2 = Math.random() * Math.PI * 2, r2 = 28 + Math.random() * 78;
                sc.dados.blips.push({
                    id: sc.P(Math.cos(ang2) * r2, 0, Math.sin(ang2) * r2, { c: cores[b], r: 2.6, a: 0.5 }),
                    ang: ang2, brilho: 0
                });
            }
        },
        tick: function (sc, dt) {
            var ang = sc.t * 1.35;
            sc.dados.vassoura.forEach(function (v, i) {
                var a2 = ang - i * 0.075;
                sc.pts[v.ponta].x = Math.cos(a2) * 112;
                sc.pts[v.ponta].z = Math.sin(a2) * 112;
            });
            sc.dados.blips.forEach(function (bl) {
                var delta = ((ang - bl.ang) % (Math.PI * 2) + Math.PI * 2) % (Math.PI * 2);
                if (delta < 0.06) bl.brilho = 1;
                bl.brilho = Math.max(0, bl.brilho - dt * 0.7);
                var p = sc.pts[bl.id];
                p.a = 0.35 + bl.brilho * 0.65;
                p.r = 2.6 + bl.brilho * 2.6;
            });
        }
    };

    // — TAREFAS: kanban 3D, cartões fluindo até "Concluída" e ficando verdes —
    CENAS.kanban = {
        fit: 310, rx: -0.10, ry: -0.22, wobble: 0.05, spin: 0,
        build: function (sc) {
            var COLS = [-84, 0, 84];
            ['Pendente', 'Executando', 'Concluída'].forEach(function (nome, i) {
                var cor = i === 0 ? GOLD : (i === 1 ? WHT : EMER);
                sc.polilinha([[COLS[i] - 34, 88, 0], [COLS[i] + 34, 88, 0], [COLS[i] + 34, -92, 0], [COLS[i] - 34, -92, 0]],
                    { c: cor, a: 0.35, w: 1.2, fechar: true, r: 0 });
                sc.P(COLS[i], 104, 0, { c: cor, r: 2.2, a: 0.9, lbl: nome, lblC: cor, lblDy: -12 });
            });
            sc.dados.cols = COLS;
            sc.dados.cartoes = [];
            for (var k = 0; k < 4; k++) {
                var card = { col: 0, prox: 1.2 + k * 1.9, mov: null };
                card.box = sc.polilinha([[-26, 14, 0], [26, 14, 0], [26, -14, 0], [-26, -14, 0]],
                    { c: GOLD, a: 0.7, w: 1.4, fechar: true, r: 1.4 });
                card.linha = sc.E(sc.P(-18, 0, 2, { r: 0 }), sc.P(14, 0, 2, { r: 0 }), { c: GOLD, a: 0.5, w: 2 });
                card.pos = { x: COLS[0], y: 52 - k * 42 };
                sc.dados.cartoes.push(card);
            }
            sc.dados.chegados = [4, 0, 0]; // ocupação por coluna (define o slot de quem chega)
        },
        tick: function (sc, dt) {
            var COLS = sc.dados.cols;
            var todosNoFim = sc.dados.cartoes.every(function (c) { return c.col === 2 && !c.mov; });
            if (todosNoFim && !sc.dados.resetEm) sc.dados.resetEm = sc.t + 2.4;
            if (sc.dados.resetEm && sc.t >= sc.dados.resetEm) {
                sc.dados.resetEm = 0;
                sc.dados.chegados = [4, 0, 0];
                sc.dados.cartoes.forEach(function (c, k) {
                    c.col = 0; c.mov = null; c.prox = sc.t + 0.8 + k * 1.9;
                    c.pos = { x: COLS[0], y: 52 - k * 42 };
                });
            }
            sc.dados.cartoes.forEach(function (card) {
                if (!card.mov && card.col < 2 && sc.t >= card.prox) {
                    var destinoCol = card.col + 1;
                    var slot = sc.dados.chegados[destinoCol] % 4;
                    sc.dados.chegados[destinoCol]++;
                    card.mov = { deX: card.pos.x, deY: card.pos.y, ateX: COLS[destinoCol], ateY: 52 - slot * 42, t: 0 };
                    card.col = destinoCol;
                }
                if (card.mov) {
                    card.mov.t += dt * 1.1;
                    var p = easeInOut(clamp(card.mov.t, 0, 1));
                    card.pos.x = lerp(card.mov.deX, card.mov.ateX, p);
                    card.pos.y = lerp(card.mov.deY, card.mov.ateY, p) + Math.sin(p * Math.PI) * 30;
                    if (card.mov.t >= 1) { card.mov = null; card.prox = sc.t + 1.6 + Math.random() * 1.4; }
                }
                var cor = card.col === 0 ? GOLD : (card.col === 1 ? WHT : EMER);
                var forma = [[-26, 14], [26, 14], [26, -14], [-26, -14]];
                card.box.p.forEach(function (pid, i) {
                    sc.pts[pid].x = card.pos.x + forma[i][0];
                    sc.pts[pid].y = card.pos.y + forma[i][1];
                    sc.pts[pid].c = cor;
                });
                card.box.e.forEach(function (eid) { sc.eds[eid].c = cor; sc.eds[eid].a = card.mov ? 1 : 0.7; });
                var l = sc.eds[card.linha];
                sc.pts[l.i].x = card.pos.x - 18; sc.pts[l.i].y = card.pos.y;
                sc.pts[l.j].x = card.pos.x + (card.col === 2 ? 18 : 14); sc.pts[l.j].y = card.pos.y;
                l.c = cor; l.a = card.col === 2 ? 0.85 : 0.5;
            });
        }
    };

    /* ══ 7. Dados dos módulos (venda) ═════════════════════════════════════ */
    var WHATS = 'https://wa.me/5541996369717';
    var MODS = {
        'analise-produto': {
            nome: 'Análise de Produto com IA',
            kicker: 'Inteligência Artificial aplicada',
            cena: 'hubIA',
            resumo: 'O detetive digital do seu estoque: a IA cruza vendas, compras, movimentação e saldo loja a loja no ERP e entrega o diagnóstico da divergência em segundos — com plano de ação pronto.',
            bullets: [
                'Diagnóstico em segundos — não em dias de investigação manual',
                'Cruza movimentação de 30 dias e o estoque de todas as filiais',
                'Entende prints e planilhas: cole a evidência e a IA analisa',
                'Vira tarefa dirigida para a loja com um clique'
            ]
        },
        'dash': {
            nome: 'Painel de Quebras (BI)',
            kicker: 'Visão executiva da perda',
            cena: 'bars',
            resumo: 'Toda a perda da operação em um só painel: quebra por motivo, por filial e por departamento, com metas e evolução mês a mês — em tempo real, não no fechamento.',
            bullets: [
                'KPIs de perda sobre venda por loja e consolidado',
                'Quebra por departamento direto do ERP, GTIN a GTIN',
                'Comparativos mensais e ranking de filiais',
                'Exportação em PDF para a reunião de resultado'
            ]
        },
        'inv': {
            nome: 'Inventário Rotativo',
            kicker: 'Acuracidade de estoque',
            cena: 'scangrid',
            resumo: 'Bipagem rápida no celular ou coletor, contagem dirigida e trilha de auditoria completa — com workflow de aprovação onde quem conta não é quem aprova.',
            bullets: [
                'Bipagem com histórico e auditoria item a item',
                'Divergências priorizadas pela IA (top ofensores do lote)',
                'Exclusão e cancelamento passam por aprovação de admin',
                'Resultado consolidado por loja na hora'
            ]
        },
        'val': {
            nome: 'Validade (Shelf Life)',
            kicker: 'Perda evitada',
            cena: 'expiry',
            resumo: 'O mapa de vencimentos da sua operação: produtos próximos do prazo viram ação preventiva — rebaixa, troca ou devolução — antes de virarem quebra.',
            bullets: [
                'Cadastro por GTIN com datas e quantidades por loja',
                'Priorização automática do que vence primeiro',
                'Correção de posição com estorno auditado',
                'Histórico para cobrar a execução da equipe'
            ]
        },
        'checklist': {
            nome: 'Checklist & Rotinas',
            kicker: 'Execução na ponta',
            cena: 'checklist',
            resumo: 'Auditorias e rotinas de loja com foto, pontuação automática e plano de ação com prazo — a disciplina da matriz chegando à ponta, todos os dias.',
            bullets: [
                'Modelos por área: perecíveis, docas, frente de caixa e mais',
                'Fotos anexadas como evidência de cada resposta',
                'Pontuação e nota por loja em tempo real',
                'Plano de ação vira tarefa com responsável e e-mail'
            ]
        },
        'caixa': {
            nome: 'Caixa & Preços',
            kicker: 'Margem no PDV',
            cena: 'pdv',
            resumo: 'A proteção da margem no lugar onde o dinheiro passa: auditoria de frente de caixa e caça à divergência entre gôndola e PDV.',
            bullets: [
                'Ocorrências de caixa com valor, motivo e operador',
                'Auditoria de preço com % de divergência por loja',
                'Acompanhamento de quebras de caixa recorrentes',
                'Gráficos de evolução para agir no ofensor certo'
            ]
        },
        'rec': {
            nome: 'Docas & Recebimento',
            kicker: 'Porta de entrada',
            cena: 'docas',
            resumo: 'Conferência e registro de divergência na entrada da mercadoria: o erro morre na doca, antes de contaminar o estoque virtual.',
            bullets: [
                'Divergências de recebimento com custo apurado',
                'Indicadores por fornecedor e por loja',
                'Notas pendentes integradas ao ERP',
                'Relatório em PDF para devolutiva ao comercial'
            ]
        },
        'negativos': {
            nome: 'Estoque Negativo',
            kicker: 'Radar diário',
            cena: 'negbars',
            resumo: 'O radar dos saldos impossíveis: itens com estoque negativo chegam do ERP todos os dias, com o acatamento das correções acompanhado loja a loja.',
            bullets: [
                'Feed diário direto do BI do ERP',
                'Acatamento medido por loja e por mês',
                'Fechamento mensal preservado no histórico',
                'Gera inventário dirigido dos ofensores'
            ]
        },
        'uso-consumo': {
            nome: 'Uso e Consumo',
            kicker: 'Consumo interno',
            cena: 'flow',
            resumo: 'Requisição de material entre lojas e depósito com aprovação e rastreio — o fim do consumo interno invisível que aparece depois como "perda desconhecida".',
            bullets: [
                'Fluxo pedido → aprovação → atendimento rastreado',
                'Custo alocado na loja que realmente consumiu',
                'Equipe integrada à gestão de acessos',
                'Histórico completo por período e por loja'
            ]
        },
        'score': {
            nome: 'Score de Risco',
            kicker: 'Controladoria',
            cena: 'radar',
            resumo: 'O ranking de risco da operação: os sinais de todos os módulos combinados em uma nota por filial, para direcionar auditoria e atenção para onde rende mais.',
            bullets: [
                'Nota de risco por loja, atualizada com dados vivos',
                'Pesos por indicador definidos pela controladoria',
                'Aponta onde a auditoria presencial rende mais',
                'Evolução do risco ao longo dos meses'
            ]
        },
        'tar': {
            nome: 'Tarefas & Planos de Ação',
            kicker: 'Execução cobrada',
            cena: 'kanban',
            resumo: 'O plano de ação que não morre na reunião: tarefa com responsável, prazo, loja e evidência — nascendo do diagnóstico da IA, do checklist ou do dia a dia, e cobrada até concluir.',
            bullets: [
                'Diagnóstico da IA vira tarefa dirigida com um clique',
                'Responsável, prazo e valor de risco definidos na criação',
                'Conclusão exige evidência — nada se perde no "feito de boca"',
                'Relatório em PDF do que foi feito (e do que ainda não foi)'
            ]
        }
    };

    /* ══ 7b. Telas do sistema com efeitos (réplica fiel da UI real) ═══════
       Montadas 100% via createElement/textContent (CSP + eslint no-unsanitized).
       Cada módulo tem uma tela com "flips": valores que nascem vermelhos e viram
       verdes (correção acontecendo na frente do visitante). A IA tem 3 passos em
       sequência — estoque loja a loja → histórico 30d → diagnóstico — a trajetória
       real que o módulo percorre no ERP. */
    var TELAS = {
        'analise-produto': {
            tag: 'IA · ao vivo', passos: [
                {
                    chip: 'Estoque loja a loja', titulo: 'Saldo Loja a Loja — ERP', blocos: [
                        { t: 'thead', c: ['Loja/Filial', 'Saldo', 'Últ. venda', 'Situação'] },
                        { t: 'row', c: [{ x: 'Loja 01 — Centro' }, { x: '12 un', num: 1 }, { x: 'ontem' }, { x: 'OK', cor: 'verde' }] },
                        { t: 'row', c: [{ x: 'Loja 03 — Bairro' }, { x: '−4 un', num: 1, cor: 'vermelho', pulsa: 1 }, { x: 'há 31 dias', cor: 'vermelho' }, { x: 'ALERTA', cor: 'vermelho' }] },
                        { t: 'row', c: [{ x: 'CD — Depósito' }, { x: '96 un', num: 1 }, { x: '—' }, { x: 'OK', cor: 'verde' }] },
                        { t: 'texto', x: 'A IA compara o saldo de todas as filiais e acha onde a divergência mora.' }
                    ]
                },
                {
                    chip: 'Histórico 30 dias', titulo: 'Movimentação Recente — 30 dias', blocos: [
                        { t: 'linha', ic: '+', x: 'Entrada NF 48.213 — 24 un', sub: '12/06 · recebimento conferido', cor: 'verde' },
                        { t: 'linha', ic: '→', x: 'Venda média 1,8 un/dia', sub: 'ritmo estável nas 4 semanas' },
                        { t: 'linha', ic: '!', x: 'Ajuste de inventário −6 un', sub: '28/06 · sem justificativa registrada', cor: 'vermelho', pulsa: 1 },
                        { t: 'texto', x: 'Compras, vendas e ajustes na linha do tempo: o rastro do problema aparece.' }
                    ]
                },
                {
                    chip: 'Diagnóstico & plano', titulo: 'Diagnóstico da IA', blocos: [
                        { t: 'texto', x: 'Provável quebra de validade não lançada na Loja 03 (confiança 78%). O saldo virtual está acima do físico desde o ajuste de 28/06.' },
                        { t: 'flipbig', label: 'Divergência — Loja 03', de: '−4 un', para: '0 un' },
                        { t: 'chip', x: '✓ Tarefa dirigida criada → Loja 03', atraso: 3000 }
                    ]
                }
            ]
        },
        'dash': {
            tag: 'Painel BI', titulo: 'Quebra sobre Venda — Rede', blocos: [
                {
                    t: 'kpi3', itens: [
                        { l: 'Quebra do mês', v: '2,10%', flip: { para: '1,42%' } },
                        { l: 'Meta', v: '1,60%' },
                        { l: 'Economia', v: 'R$ 8,4 mil', cor: 'verde' }
                    ]
                },
                { t: 'barras', vals: [58, 42, 76, 50, 34, 66], hi: 2 },
                { t: 'chip', x: '✓ Meta batida em 4 de 6 lojas', atraso: 2600 }
            ]
        },
        'inv': {
            tag: 'Inventário', titulo: 'Auditoria do Lote — PAR 7', blocos: [
                { t: 'thead', c: ['GTIN', 'Contado', 'Virtual', 'Diverg.'] },
                { t: 'row', c: [{ x: '789…012' }, { x: '48', num: 1 }, { x: '48', num: 1 }, { x: 'OK', cor: 'verde' }] },
                { t: 'row', c: [{ x: '789…335' }, { x: '12', num: 1 }, { x: '20', num: 1 }, { x: '−8', num: 1, cor: 'vermelho', pulsa: 1, flip: { para: '0 ✓' } }] },
                { t: 'row', c: [{ x: '789…881' }, { x: '30', num: 1 }, { x: '29', num: 1 }, { x: '+1', num: 1, cor: 'dourado' }] },
                { t: 'chip', x: '✓ Ajuste aprovado pelo admin — trilha de auditoria gravada', atraso: 2800 }
            ]
        },
        'val': {
            tag: 'Validade', titulo: 'Vencimentos — próximos 7 dias', blocos: [
                { t: 'thead', c: ['Produto', 'Qtde', 'Vence em', 'Ação'] },
                { t: 'row', c: [{ x: 'Iogurte 170g' }, { x: '36 un', num: 1 }, { x: '2 dias', cor: 'vermelho', pulsa: 1 }, { x: 'Rebaixa', cor: 'vermelho', flip: { para: 'Aplicada ✓' } }] },
                { t: 'row', c: [{ x: 'Presunto fatiado' }, { x: '8 un', num: 1 }, { x: '4 dias', cor: 'dourado' }, { x: 'Troca', cor: 'dourado' }] },
                { t: 'row', c: [{ x: 'Leite UHT 1L' }, { x: '120 un', num: 1 }, { x: '12 dias' }, { x: 'OK', cor: 'verde' }] },
                { t: 'chip', x: '✓ Perda evitada nesta ação: R$ 214,40', atraso: 2800 }
            ]
        },
        'checklist': {
            tag: 'Checklist', titulo: 'Rotina de Perecíveis — Loja 02', blocos: [
                { t: 'linha', ic: '✓', x: 'Temperatura das câmaras frias', sub: 'conforme · foto anexada', cor: 'verde' },
                { t: 'linha', ic: '✓', x: 'FIFO aplicado na reposição', sub: 'conforme', cor: 'verde' },
                { t: 'linha', ic: '!', x: 'Etiquetas de rebaixa vencidas', sub: 'não conforme · vira plano de ação', cor: 'vermelho', pulsa: 1 },
                { t: 'flipbig', label: 'Nota da loja', de: '62%', para: '91%' },
                { t: 'chip', x: '✓ Plano de ação gerado com responsável e prazo', atraso: 3000 }
            ]
        },
        'caixa': {
            tag: 'Caixa & Preços', titulo: 'Divergência Gôndola × PDV', blocos: [
                { t: 'thead', c: ['Item', 'Gôndola', 'PDV', 'Status'] },
                { t: 'row', c: [{ x: 'Café 500g' }, { x: 'R$ 18,90', num: 1 }, { x: 'R$ 21,50', num: 1, cor: 'vermelho', pulsa: 1 }, { x: 'DIVERGENTE', cor: 'vermelho', flip: { para: 'CORRIGIDO ✓' } }] },
                { t: 'row', c: [{ x: 'Arroz 5kg' }, { x: 'R$ 24,90', num: 1 }, { x: 'R$ 24,90', num: 1 }, { x: 'OK', cor: 'verde' }] },
                { t: 'chip', x: '✓ Auditoria de frente de caixa: 2 ocorrências tratadas', atraso: 2800 }
            ]
        },
        'rec': {
            tag: 'Docas', titulo: 'Conferência Cega — NF 52.113', blocos: [
                { t: 'thead', c: ['Item', 'NF', 'Físico', 'Diverg.'] },
                { t: 'row', c: [{ x: 'Refrigerante 2L' }, { x: '24', num: 1 }, { x: '24', num: 1 }, { x: 'OK', cor: 'verde' }] },
                { t: 'row', c: [{ x: 'Biscoito recheado' }, { x: '36', num: 1 }, { x: '33', num: 1 }, { x: '−3', num: 1, cor: 'vermelho', pulsa: 1, flip: { para: 'Tratada ✓' } }] },
                { t: 'chip', x: '✓ Devolutiva enviada ao comercial com custo apurado', atraso: 2800 }
            ]
        },
        'negativos': {
            tag: 'Negativos', titulo: 'Saldos Negativos — hoje, 06:00', blocos: [
                { t: 'thead', c: ['GTIN', 'Loja', 'Saldo'] },
                { t: 'row', c: [{ x: '789…441' }, { x: 'Loja 01' }, { x: '−12', num: 1, cor: 'vermelho', pulsa: 1, flip: { para: '0 ✓' } }] },
                { t: 'row', c: [{ x: '789…208' }, { x: 'Loja 03' }, { x: '−5', num: 1, cor: 'vermelho', pulsa: 1, flip: { para: '0 ✓' } }] },
                { t: 'flipbig', label: 'Acatamento do dia', de: '48%', para: '92%' },
                { t: 'chip', x: '✓ Feed do BI processado — fechamento preservado no histórico', atraso: 3200 }
            ]
        },
        'uso-consumo': {
            tag: 'Uso e Consumo', titulo: 'Requisição #128 — Loja 03 → CD', blocos: [
                { t: 'linha', ic: '→', x: '12 un — Papel toalha interfolha', sub: 'solicitado por João · Loja 03' },
                { t: 'thead', c: ['Etapa', 'Status'] },
                { t: 'row', c: [{ x: 'Pedido' }, { x: 'Enviado', cor: 'verde' }] },
                { t: 'row', c: [{ x: 'Aprovação' }, { x: 'Pendente', cor: 'vermelho', pulsa: 1, flip: { para: 'Aprovada ✓' } }] },
                { t: 'row', c: [{ x: 'Atendimento' }, { x: 'Aguardando', cor: 'dourado', flip: { para: 'Separado ✓', atraso: 3400 } }] },
                { t: 'chip', x: '✓ Custo alocado na loja que consumiu', atraso: 4000 }
            ]
        },
        'score': {
            tag: 'Score de Risco', titulo: 'Ranking de Risco — filiais', blocos: [
                { t: 'thead', c: ['Filial', 'Score', 'Tendência'] },
                { t: 'row', c: [{ x: 'Loja 03' }, { x: '78 · alto', cor: 'vermelho', pulsa: 1 }, { x: '↑', cor: 'vermelho' }] },
                { t: 'row', c: [{ x: 'Loja 01' }, { x: '41 · médio', cor: 'dourado' }, { x: '→', cor: 'dourado' }] },
                { t: 'row', c: [{ x: 'Loja 02' }, { x: '22 · baixo', cor: 'verde' }, { x: '↓', cor: 'verde' }] },
                { t: 'flipbig', label: 'Loja 03 — após o plano de ação', de: '78', para: '54' },
                { t: 'chip', x: '✓ Auditoria presencial direcionada para onde rende', atraso: 3200 }
            ]
        },
        'tar': {
            tag: 'Tarefas', titulo: 'Tarefa #214 — Loja 03', blocos: [
                { t: 'linha', ic: '@', x: 'Verificar validade do iogurte 170g', sub: 'origem: diagnóstico da IA · risco R$ 214' },
                { t: 'thead', c: ['Campo', 'Valor'] },
                { t: 'row', c: [{ x: 'Responsável' }, { x: 'Maria — Loja 03' }] },
                { t: 'row', c: [{ x: 'Prazo' }, { x: 'sexta-feira', cor: 'dourado' }] },
                { t: 'row', c: [{ x: 'Status' }, { x: 'Pendente', cor: 'vermelho', pulsa: 1, flip: { para: 'Concluída ✓' } }] },
                { t: 'chip', x: '✓ Evidência anexada: foto da gôndola corrigida', atraso: 3200 }
            ]
        }
    };

    var telaTimers = [];

    function elC(tag, cls, txt) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (txt != null) e.textContent = txt;
        return e;
    }

    function corClasse(cor) { return cor ? ' ls-' + cor : ''; }

    // monta UMA tela (header + blocos) e devolve {no, flips, chips}
    function montarTela(def, titulo) {
        var flips = [], chips = [];
        var tela = elC('div', 'ls-screen');
        var inner = elC('div', 'ls-screen-inner');
        tela.appendChild(inner);
        var head = elC('div', 'ls-scr-head');
        var dots = elC('span', 'ls-scr-dots');
        dots.appendChild(elC('i', 'ls-dot-r'));
        dots.appendChild(elC('i', 'ls-dot-a'));
        dots.appendChild(elC('i', 'ls-dot-v'));
        head.appendChild(dots);
        head.appendChild(elC('span', 'ls-scr-titulo', titulo));
        head.appendChild(elC('span', 'ls-scr-tag', def.tag));
        inner.appendChild(head);
        var corpo = elC('div', 'ls-scr-corpo');
        inner.appendChild(corpo);

        def.blocos.forEach(function (b) {
            if (b.t === 'thead') {
                var th = elC('div', 'ls-scr-row ls-scr-thead');
                b.c.forEach(function (c) { th.appendChild(elC('span', null, c)); });
                corpo.appendChild(th);
            } else if (b.t === 'row') {
                var row = elC('div', 'ls-scr-row');
                b.c.forEach(function (c) {
                    var cel = elC('span', (c.num ? 'ls-num' : '') + corClasse(c.cor) + (c.pulsa ? ' ls-pulsa' : ''), c.x);
                    if (c.flip) flips.push({ el: cel, para: c.flip.para, atraso: c.flip.atraso });
                    row.appendChild(cel);
                });
                corpo.appendChild(row);
            } else if (b.t === 'linha') {
                var ln = elC('div', 'ls-scr-linha' + (b.pulsa ? ' ls-pulsa' : ''));
                ln.appendChild(elC('span', 'ls-scr-ic' + corClasse(b.cor), b.ic));
                var txts = elC('span', 'ls-scr-linha-txt');
                txts.appendChild(elC('b', corClasse(b.cor) || null, b.x));
                txts.appendChild(elC('small', null, b.sub));
                ln.appendChild(txts);
                corpo.appendChild(ln);
            } else if (b.t === 'kpi3') {
                var grade = elC('div', 'ls-scr-kpis');
                b.itens.forEach(function (it) {
                    var kpi = elC('div', 'ls-scr-kpi');
                    kpi.appendChild(elC('small', null, it.l));
                    var v = elC('b', 'ls-num' + (it.flip ? ' ls-vermelho ls-pulsa' : corClasse(it.cor)), it.v);
                    if (it.flip) flips.push({ el: v, para: it.flip.para });
                    kpi.appendChild(v);
                    grade.appendChild(kpi);
                });
                corpo.appendChild(grade);
            } else if (b.t === 'flipbig') {
                var big = elC('div', 'ls-scr-flipbig');
                big.appendChild(elC('small', null, b.label));
                var val = elC('b', 'ls-num ls-vermelho ls-pulsa', b.de);
                flips.push({ el: val, para: b.para });
                big.appendChild(val);
                corpo.appendChild(big);
            } else if (b.t === 'barras') {
                var ch = elC('div', 'ls-scr-barras');
                b.vals.forEach(function (v, i) {
                    var barra = elC('i', i === b.hi ? 'ls-barra-hi' : null);
                    barra.style.height = v + '%';
                    ch.appendChild(barra);
                });
                corpo.appendChild(ch);
            } else if (b.t === 'chip') {
                var chip = elC('div', 'ls-scr-chip', b.x);
                chips.push({ el: chip, atraso: b.atraso || 2600 });
                corpo.appendChild(chip);
            } else if (b.t === 'texto') {
                corpo.appendChild(elC('p', 'ls-scr-texto', b.x));
            }
        });
        return { no: tela, flips: flips, chips: chips };
    }

    // dispara scan + flips vermelho→verde + chips numa tela já no DOM
    function rodarEfeitos(tela) {
        if (REDUCED) { // estado final direto, sem coreografia
            tela.flips.forEach(function (f) {
                f.el.textContent = f.para;
                f.el.classList.remove('ls-vermelho', 'ls-dourado', 'ls-pulsa');
                f.el.classList.add('ls-verde');
            });
            tela.chips.forEach(function (c) { c.el.classList.add('ls-visivel'); });
            return;
        }
        var scan = elC('div', 'ls-scr-scan');
        tela.no.appendChild(scan);
        tela.flips.forEach(function (f, i) {
            telaTimers.push(setTimeout(function () {
                f.el.textContent = f.para;
                f.el.classList.remove('ls-vermelho', 'ls-dourado', 'ls-pulsa');
                f.el.classList.add('ls-verde', 'ls-pop');
            }, f.atraso || (1600 + i * 700)));
        });
        tela.chips.forEach(function (c) {
            telaTimers.push(setTimeout(function () { c.el.classList.add('ls-visivel'); }, c.atraso));
        });
    }

    function limparTelaSistema() {
        telaTimers.forEach(clearTimeout);
        telaTimers = [];
        var wrap = document.getElementById('ls-modal-screen');
        if (wrap) wrap.replaceChildren();
    }

    // ponto de entrada: monta a(s) tela(s) do módulo no palco do modal
    function montarTelaSistema(modId) {
        var wrap = document.getElementById('ls-modal-screen');
        var def = TELAS[modId];
        limparTelaSistema();
        if (!wrap || !def) return;

        if (!def.passos) {
            var tela = montarTela(def, def.titulo);
            wrap.appendChild(tela.no);
            rodarEfeitos(tela);
            return;
        }

        // IA: trajetória em passos (estoque → histórico → diagnóstico), em loop
        var stepsBar = elC('div', 'ls-steps');
        var stepEls = def.passos.map(function (p, i) {
            var s = elC('span', 'ls-step');
            s.appendChild(elC('b', null, String(i + 1)));
            s.appendChild(elC('span', null, p.chip));
            stepsBar.appendChild(s);
            return s;
        });
        wrap.appendChild(stepsBar);
        var palco = elC('div', 'ls-steps-palco');
        wrap.appendChild(palco);

        function mostrarPasso(k) {
            stepEls.forEach(function (s, i) { s.classList.toggle('ls-ativo', i === k); });
            var passo = def.passos[k];
            var tela = montarTela({ tag: def.tag, blocos: passo.blocos }, passo.titulo);
            tela.no.classList.add('ls-screen-entra');
            palco.replaceChildren(tela.no);
            rodarEfeitos(tela);
            if (!REDUCED) {
                telaTimers.push(setTimeout(function () { mostrarPasso((k + 1) % def.passos.length); }, 5600));
            }
        }
        // com motion reduzido, mostra direto o diagnóstico (estado final da história)
        mostrarPasso(REDUCED ? def.passos.length - 1 : 0);
    }

    /* ══ 8. Modal 3D dos módulos ══════════════════════════════════════════ */
    var modal, cenaModal = null, focoAnterior = null;

    function abrirModal(modId) {
        var mod = MODS[modId];
        if (!mod || !modal) return;
        document.getElementById('ls-modal-title').textContent = mod.nome;
        document.getElementById('ls-modal-kicker').textContent = mod.kicker;
        document.getElementById('ls-modal-resumo').textContent = mod.resumo;
        document.getElementById('ls-modal-stage-label').textContent = 'SIMULAÇÃO 3D · ' + mod.nome;
        var slots = modal.querySelectorAll('.ls-modal-bullet');
        slots.forEach(function (slot, i) {
            slot.textContent = mod.bullets[i] || '';
            slot.parentElement.style.display = mod.bullets[i] ? '' : 'none';
        });
        var zap = document.getElementById('ls-modal-cta-whats');
        zap.href = WHATS + '?text=' + encodeURIComponent('Olá! Vim pelo site da LUCROSEGURO e quero saber mais sobre o módulo ' + mod.nome + '.');
        modal.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
        focoAnterior = document.activeElement;
        var btnFechar = document.getElementById('ls-modal-fechar');
        if (btnFechar) btnFechar.focus();
        var canvas = document.getElementById('ls-modal-canvas');
        if (cenaModal) destruirCena(cenaModal);
        cenaModal = mkCena(canvas, CENAS[mod.cena] || CENAS.hubIA);
        montarTelaSistema(modId);
    }

    function fecharModal() {
        if (!modal || modal.hasAttribute('hidden')) return;
        modal.setAttribute('hidden', '');
        document.documentElement.style.overflow = '';
        if (cenaModal) { destruirCena(cenaModal); cenaModal = null; }
        limparTelaSistema();
        if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
    }

    function initModal() {
        modal = document.getElementById('ls-modal');
        if (!modal) return;
        // delegação: qualquer [data-mod] dentro da landing abre o modal
        root.addEventListener('click', function (ev) {
            var gatilho = ev.target.closest('[data-mod]');
            if (gatilho) { ev.preventDefault(); abrirModal(gatilho.getAttribute('data-mod')); }
        });
        modal.addEventListener('click', function (ev) {
            if (ev.target.closest('[data-ls-fechar]')) fecharModal();
            if (ev.target.classList.contains('ls-modal-backdrop')) fecharModal();
        });
        document.addEventListener('keydown', function (ev) {
            if (ev.key === 'Escape') fecharModal();
        });
        // CTA "agendar" navega pra #contato — fecha o modal e deixa a âncora agir
        var agendar = document.getElementById('ls-modal-cta-agendar');
        if (agendar) agendar.addEventListener('click', function () { fecharModal(); });
    }

    function initCalculadoraPerdas() {
        var inputFat = document.getElementById('calc-fat-input');
        var selectSeg = document.getElementById('calc-seg-select');
        if (!inputFat || !selectSeg) return;

        function formatarNumeroMilhar(str) {
            var limpo = String(str || '').replace(/\D/g, '');
            if (!limpo) return '';
            var num = parseInt(limpo, 10);
            return num.toLocaleString('pt-BR');
        }

        function recalcular() {
            var rawDigits = inputFat.value.replace(/\D/g, '');
            var fat = parseFloat(rawDigits) || 0;

            var formatado = formatarNumeroMilhar(rawDigits);
            if (inputFat.value !== formatado && formatado !== '') {
                inputFat.value = formatado;
            }

            var pctPerda = parseFloat(selectSeg.value) || 1.51;
            var perdaMensal = (fat * pctPerda) / 100;
            var perdaAnual = perdaMensal * 12;

            var valQuebras = perdaMensal * 0.332;
            var valVencidos = perdaMensal * 0.370;
            var valFurtos = perdaMensal * 0.298;
            var valRecuperado = perdaAnual * 0.50;

            var elQ = document.getElementById('calc-val-quebras');
            var elV = document.getElementById('calc-val-vencidos');
            var elF = document.getElementById('calc-val-furtos');
            var elA = document.getElementById('calc-val-anual');
            var elR = document.getElementById('calc-val-recuperado');

            if (elQ) elQ.textContent = 'R$ ' + fmtBR(valQuebras, 0) + ' / mês';
            if (elV) elV.textContent = 'R$ ' + fmtBR(valVencidos, 0) + ' / mês';
            if (elF) elF.textContent = 'R$ ' + fmtBR(valFurtos, 0) + ' / mês';
            if (elA) elA.textContent = 'R$ ' + fmtBR(perdaAnual, 0);
            if (elR) elR.textContent = 'R$ ' + fmtBR(valRecuperado, 0) + ' / ano';
        }

        inputFat.addEventListener('input', recalcular);
        selectSeg.addEventListener('change', recalcular);
        recalcular();
    }

    /* ══ 9. Boot ══════════════════════════════════════════════════════════ */
    function init() {
        initReveal();
        initCounters();
        initTilt();
        initNavEParallax();
        initModal();
        initCalculadoraPerdas();
        var heroCanvas = document.getElementById('ls-hero-canvas');
        if (heroCanvas) {
            var cena = mkCena(heroCanvas, CENAS.hero);
            if (!REDUCED && !NO_HOVER) {
                var heroSec = heroCanvas.closest('section');
                if (heroSec) {
                    heroSec.addEventListener('pointermove', function (ev) {
                        var r = heroSec.getBoundingClientRect();
                        cena.mouse.x = ((ev.clientX - r.left) / r.width - 0.5) * 2;
                        cena.mouse.y = ((ev.clientY - r.top) / r.height - 0.5) * 2;
                    });
                    heroSec.addEventListener('pointerleave', function () { cena.mouse.x = 0; cena.mouse.y = 0; });
                }
            }
        }
        var iaCanvas = document.getElementById('ls-ia-canvas');
        if (iaCanvas) mkCena(iaCanvas, CENAS.hubIA);
    }

    // script clássico no fim do body: DOM já parseado; guard segue a pegadinha nº 3
    // do método (DOMContentLoaded pode já ter passado quando há await antes de nós)
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
